import autoComplete from "@tarekraafat/autocomplete.js";
import bb from "blingblingjs";

// Clear the input value when clicking the 'x'
bb(".js-fn__clear-search").on("click", () => {
    bb(".js-el__search-input").forEach(el => {
        // Autocomplete doesn't appear to have any built in methods to do this...
        el.value = ""; // Set the value manually
        el.dispatchEvent(new Event("input")); // Mimic a keypress to clear any search results
    });
});

bb('.js-el__searchbox').forEach(el => {

    let data = bb('.js-el__searchbox-data', el)[0].value;
    data = JSON.parse(data);

    new autoComplete({
        data: {
            src: data,
            key: ["title"], 
            cache: false
        },
        selector : () => bb(".js-el__search-input", el)[0],
        sort: (a, b) => {
            if (a.match < b.match) return -1;
            if (a.match > b.match) return 1;
            return 0;
        }, 
        searchEngine: "strict", 
        resultsList: {
            render: true,
            container: source => {
                source.setAttribute("class", "autoComplete_list");
            },
            destination: bb(".js-el__auto-complete_result_wrapper", el)[0],
            position: "afterbegin",
            element: "ul"
        },
        highlight: true,
        resultItem: {
            content: (data, source) => {("a");
                const link = document.createElement("a");
                link.innerHTML = data.match;
                link.href = data.value.url;
                source.appendChild(link);
            },
            element: "li"
        },
        noResults: () => {
            const result = document.createElement("li");
            result.setAttribute("class", "no_result");
            result.setAttribute("tabindex", "1");
            result.innerHTML = "No Results";
            bb(".autoComplete_list", el)[0].appendChild(result);
        },
        onSelection: feedback => {
            window.open(feedback.selection.value.url,"_self"); 
        }
    });


});